import * as React from "react";

/**
 * Store mínima que sinaliza "navegação em andamento".
 *
 * Necessária porque o react-router v7 envolve as trocas de rota em
 * `startTransition`: quando o chunk da página (React.lazy) ainda não foi
 * baixado, o React mantém a tela atual visível e o `<Suspense>` de
 * `routes.tsx` nunca aparece. Sem este sinal o clique não produz nenhum
 * feedback até o download do chunk terminar.
 *
 * Não usamos `useNavigation()` do data router porque o app inteiro está sob
 * uma única rota (`path="/*"` em `main.tsx`) sem loaders — a navegação do
 * router resolve na hora e ele volta a `idle` antes do lazy suspender.
 */

let pending = false;
const listeners = new Set<() => void>();

export function setNavPending(value: boolean) {
  if (pending === value) return;
  pending = value;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useNavPending() {
  return React.useSyncExternalStore(
    subscribe,
    () => pending,
    () => false,
  );
}
